import Control from "../../../../../../common/Controls/Control";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROSecurite = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig } = useRCPROQuestion({
    company,
  });
  return (
    <div>
      <Control
        label={inputsConfig.securiteTypesActivites.label}
        type="checkBtnList"
        name="securiteTypesActivites"
        value={company.RCPRO.securiteTypesActivites}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.securiteTypesActivites.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles.</>}
      />
      <Control
        label={inputsConfig.securiteAgentsArmes.label}
        type="btnList"
        name="securiteAgentsArmes"
        value={company.RCPRO.securiteAgentsArmes}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.securiteAgentsArmes.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <Control
        label={inputsConfig.securiteTelesurveillance.label}
        type="btnList"
        name="securiteTelesurveillance"
        value={company.RCPRO.securiteTelesurveillance}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.securiteTelesurveillance.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
    </div>
  );
};

export default RCPROSecurite;
